var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5999 74.9868H17.5273C14.6982 74.9868 12.3143 73.176 11.4082 70.6602V72.1615C11.4082 75.71 14.2843 78.5849 17.8315 78.5849H55.2984C58.8456 78.5849 61.7191 75.71 61.7191 72.1615V70.6602C60.8143 73.176 58.4291 74.9868 55.5999 74.9868Z",
    fill: "#B1B5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1294 22.3794H47.75V15.7028V8L62.1294 22.3794Z",
    fill: "#B1B5B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7498 8H17.5288C13.9228 8 11.001 10.9231 11.001 14.5278V68.4577C11.001 72.0623 13.9228 74.9854 17.5288 74.9854H55.6014C59.206 74.9854 62.1291 72.0623 62.1291 68.4577V22.3781H50.3609C48.9182 22.3781 47.7498 21.2096 47.7498 19.767V8Z",
    fill: "#ECEDEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8281 23.0696C27.5802 23.0696 28.9993 21.6492 28.9993 19.8971C28.9993 18.1451 27.5802 16.7246 25.8281 16.7246C24.076 16.7246 22.6543 18.1451 22.6543 19.8971C22.6543 21.6492 24.076 23.0696 25.8281 23.0696Z",
    fill: "#1686ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9738 28.7257V28.2048C31.9738 25.9697 30.1617 24.1562 27.9252 24.1562H23.7292C21.4928 24.1562 19.6807 25.9697 19.6807 28.2048V28.7257H31.9738Z",
    fill: "#1686ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6533 40.9464H19.4765C18.7558 40.9464 18.1709 40.3615 18.1709 39.6409V36.2099C18.1709 35.4879 18.7558 34.9043 19.4765 34.9043H53.6533C54.374 34.9043 54.9588 35.4879 54.9588 36.2099V39.6409C54.9588 40.3615 54.374 40.9464 53.6533 40.9464Z",
    fill: "url(#paint0_linear_3731_21118)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6533 52.2003H19.4765C18.7558 52.2003 18.1709 51.6167 18.1709 50.8948V47.4638C18.1709 46.7418 18.7558 46.1582 19.4765 46.1582H53.6533C54.374 46.1582 54.9588 46.7418 54.9588 47.4638V50.8948C54.9588 51.6167 54.374 52.2003 53.6533 52.2003Z",
    fill: "url(#paint1_linear_3731_21118)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1037 63.4562H19.4784C18.7577 63.4562 18.1729 62.8726 18.1729 62.1506V58.7196C18.1729 57.9976 18.7577 57.4141 19.4784 57.4141H42.1037C42.8244 57.4141 43.4092 57.9976 43.4092 58.7196V62.1506C43.4092 62.8726 42.8244 63.4562 42.1037 63.4562Z",
    fill: "url(#paint2_linear_3731_21118)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9194 34.9823C41.5744 40.3286 41.5731 49.0275 46.9194 54.3738C52.2656 59.72 60.9658 59.72 66.3121 54.3738C71.657 49.0275 71.6557 40.3286 66.3108 34.9823C60.9645 29.6361 52.2669 29.6361 46.9194 34.9823Z",
    fill: "#B4DCFB"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4916 64.9617L74.9951 57.4639C74.4859 56.9561 73.6582 56.9561 73.149 57.4639L72.7352 57.8804L70.1671 55.3111C75.4768 48.5522 75.0303 38.7162 68.8028 32.49C62.0831 25.769 51.1491 25.769 44.4281 32.49C37.7071 39.2097 37.7058 50.1463 44.4268 56.8673C50.653 63.0935 60.4904 63.5387 67.2492 58.229L69.8173 60.7983L69.4021 61.2122C68.8929 61.7227 68.8929 62.5491 69.4021 63.0582L76.8973 70.5534C77.4078 71.0626 78.2342 71.0626 78.7433 70.5534L82.4916 66.8078C83.0008 66.2986 83.0008 65.4722 82.4916 64.9617ZM66.3118 54.375C60.9643 59.7212 52.2654 59.7212 46.9191 54.375C41.5729 49.0274 41.5742 40.3285 46.9191 34.9823C52.2667 29.636 60.9643 29.636 66.3105 34.9823C71.6568 40.3285 71.6581 49.0274 66.3118 54.375Z",
    fill: "url(#paint3_linear_3731_21118)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.8681 34.9648H33.832V85.0009H83.8681V34.9648Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3731_21118",
    x1: 18.3015,
    y1: 37.8431,
    x2: 55.2918,
    y2: 38.1734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3731_21118",
    x1: 18.496,
    y1: 49.0944,
    x2: 54.6821,
    y2: 49.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3731_21118",
    x1: 18.2982,
    y1: 60.4665,
    x2: 54.4229,
    y2: 60.8464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3731_21118",
    x1: 44.3315,
    y1: 32.7446,
    x2: 81.9576,
    y2: 69.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202021"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.82c7e047fa64db50a965c4aa1af85b75.svg";
export { ForwardRef as ReactComponent };